import { createContext, useContext, useReducer } from "react";
import PropTypes from "prop-types";

const CancellationFormDetailsContext = createContext();
CancellationFormDetailsContext.displayName = "cancellationForm";

export const useCancellationFormDetails = () =>
  useContext(CancellationFormDetailsContext);

export const CancellationFormDetailsProvider = ({
  children,
  initialState,
  reducer,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <CancellationFormDetailsContext.Provider value={[state, dispatch]}>
      {children}
    </CancellationFormDetailsContext.Provider>
  );
};

CancellationFormDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    cancellationFormDetails: PropTypes.object.isRequired,
  }),
  reducer: PropTypes.func.isRequired,
};
